module.exports = __webpack_public_path__ + "static/About-9feac6d079891701093fbc870be09d3e.gif";